// extracted by mini-css-extract-plugin
export default {"customButton":"custom-button_customButton__gt5CR"};